export default class AbstractMethodError extends Error {
    constructor(methodName) {
        super(`Abstract method '${methodName}' was invoked.`);
        this.name = "AbstractMethodError";
    }
}
